import angular from 'angular';
import billfoldModule from './billfold/billfold';
import reportOrdersModule from './orders/orders';
import reportRemissionsModule from './remission/remission';
import reportPendientesItemsModule from './pendientesItems/pendientes-items';
import reportPaymentHistoryModule from './payment-history/payment-history';

let reportsModule = angular.module('app.reports', [
  billfoldModule.name,
  reportOrdersModule.name,
  reportRemissionsModule.name,
  reportPendientesItemsModule.name,
  reportPaymentHistoryModule.name
]);

export default reportsModule;



/** WEBPACK FOOTER **
 ** ./www/components/reports/reports.js
 **/